u.AutoComplete = class extends u.ForElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();

        this.style.position = 'absolute';
        this.style.cursor = 'pointer';
        this.style.zIndex = 1;

        this.$highlightClass = 'highlight';
        this.$hideTimeout = 500;
        this.$minLength = 1;

        this._latestValue = '';
        this._hideTimeout = 0;

        this._mouseDown = (evt) => {
            /**
             * When mouse down is fired, make sure it was the primary mouse button.
             */
            if (evt.button === 0) {
                let elem = evt.target;
                while (elem) {
                    if (elem instanceof u.AutoCompleteOption) {
                        this.$select(elem.$value);
                        return;
                    }
                    elem = elem.parentElement;
                }
            } else {
                evt.preventDefault();
            }
        }

        this._input = () => {
            /**
             * Handle input value change, give the update() time to respond before hiding the dropdown
             */
            const value = this.$forElement.value.trim();
            if (value !== this._latestValue) {
                this._latestValue = value;
                if (this._latestValue.length <= this.$minLength) {
                    this.$hide();
                } else {
                    clearTimeout(this._hideTimeout);
                    this._hideTimeout = setTimeout(() => this.$hide(), this.$hideTimeout);
                    this.$input(this._latestValue);
                }
            }
        };

        this._keyDown = (evt) => {
            /**
             *
             */
            switch (evt.keyCode) {
                // down
                case 40:
                    /**
                     * Highlight a option downward and prevent courser from moving to the end
                     */
                    evt.preventDefault();
                    if (this.children.length) {
                        const highlighted = this.$highlighted();
                        if (highlighted) {
                            highlighted.classList.remove(this.$highlightClass);
                            const next = highlighted.nextElementSibling;
                            if (next) {
                                next.classList.add(this.$highlightClass);
                            }
                        } else {
                            const first = this.firstElementChild;
                            first.classList.add(this.$highlightClass);
                        }
                    }
                    break;

                // up
                case 38:
                    /**
                     * Highlight a option upward and prevent courser from moving to the beginning
                     */
                    evt.preventDefault();
                    if (this.children.length) {
                        const highlighted = this.$highlighted();
                        if (highlighted) {
                            highlighted.classList.remove(this.$highlightClass);
                            const prev = highlighted.previousElementSibling;
                            if (prev) {
                                prev.classList.add(this.$highlightClass);
                            }
                        } else {
                            const last = this.lastElementChild;
                            last.classList.add(this.$highlightClass);
                        }
                    }
                    break;

                // enter
                case 13:
                    /**
                     * Prevent enter from triggering form submission when option is selected
                     */
                    const highlighted = this.$highlighted();
                    if (highlighted) {
                        evt.preventDefault();
                        this.$select(highlighted.$value);
                    } else {
                        this.$hide();
                        evt.preventDefault();
                        const value = this.$forElement.value.trim();
                        this.$search(value);
                        this.$forElement.value = '';
                    }
                    break;

                // esc
                case 27:
                    /**
                     * Just hide on ESC key
                     */
                    this.$hide();
                    break;
            }
        };

        this._blur = () => {
            /**
             * Hide on blur
             */
            this.$hide();
        }

        this._focus = () => {
            /**
             * Show on focus if options are available
             */
            if (this.children.length) {
                this.$show();
            }
        };

        this._resize = () => {
            /**
             *
             */
            this.$position();
        };
    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();
        this.$forElement.autocomplete = 'off';
        this.$position();

        // event listeners
        window.addEventListener('resize', this._resize);
        this.addEventListener('mousedown', this._mouseDown);
        this.$forElement.addEventListener('blur', this._blur);
        this.$forElement.addEventListener('focus', this._focus);
        this.$forElement.addEventListener('input', this._input);
        this.$forElement.addEventListener('keydown', this._keyDown);
    }

    detachedCallback() {
        /**
         *
         */
        super.detachedCallback();
        window.removeEventListener('resize', this._resize);
        this.removeEventListener('mousedown', this._mouseDown);
        this.$forElement.removeEventListener('blur', this._blur);
        this.$forElement.removeEventListener('focus', this._focus);
        this.$forElement.removeEventListener('input', this._input);
        this.$forElement.removeEventListener('keydown', this._keyDown);
    }

    $input(value) {
        /**
         * Default callback for when the input has changed
         */
    }

    $select(value) {
        /**
         * Default callback for when a option is selected
         */
        this.$hide();
        this.$forElement.value = value;
    }

    $search(value) {

    }

    $update(value, options) {
        /**
         * Callback for when options are ready to be updated
         */
        if (this._latestValue === value) {

            // remove old nodes
            let child;
            while (child = this.firstChild) {
                this.removeChild(child);
            }

            if (options.length) {
                options.forEach((value) => {
                    const elem = document.createElement('u-autocomplete-option');
                    elem.$value = value;
                    elem.$parent = this;                    
                    this.$add(elem, value);
                    this.appendChild(elem);
                });
                this.$show();
            }
        }
    }

    $add(elem, value) {
        /**
         * Default callback for when a new option is added
         */
        elem.textContent = value;
    }

    $show() {
        /**
         * Reveals the AutoComplete element
         */
        clearTimeout(this._hideTimeout);
        this.style.display = 'block';
    }

    $hide() {
        /**
         * Hide the AutoComplete element
        */
        clearTimeout(this._hideTimeout);
        this.style.display = 'none';
        const highlighted = this.$highlighted();
        if (highlighted) {
            highlighted.classList.remove(this.$highlightClass);
        }
    }

    $highlighted() {
        /**
         * Get the current highlighted option element
         */
        const children = this.children;
        for (let i = 0, child; child = children[i]; i++) {
            if (child.classList.contains(this.$highlightClass)) {
                return child;
            }
        }
        return null;
    }

    $position() {
        /**
         * Set the positioning of the autocomplete container
         */
        var rect = this.$forElement.getBoundingClientRect();
        if (rect.width > 0) {
            this.style.width = rect.width + 'px';
        }
    }
};

u.AutoComplete.register('u-autocomplete');
